import { SET_USER,SET_EVENTS,SET_TOKEN,LOG_OUT } from './type';




export const setUserData = (data) => {
  return {
    type: SET_USER,
    data
  }
};

export const setEventsData = (data) => {
  return {
    type: SET_EVENTS,
    data
  }
}
export const setToken = (data) => {
    return {
      type: SET_TOKEN,
      data
    }
};
export const setLogout = () => {
  return {
    type: LOG_OUT
  }
};

